export default __webpack_public_path__ + "static/media/cmk2020-teams-instruction.57ccad6c.pdf";